<template>
  <div class="userSection">
    <div class="container" v-if="loaded">
      <h3 v-if="userSection && userSection.length == 0">Aún no hay alumnos en la sección</h3>

      <div v-else class="flex-cards">
        <div class="card card-add" v-for="(item, index) in userSection" :key="index" @click="goToRoute(item.user.id)">
          <i class="fa-solid fa-person" style="font-size: 50px;"></i>
          <p class="card-title">{{ item.user.name }}</p>
        </div>
      </div>
    </div>

    <div class="container" v-else>
      <img src="../../assets/loading.gif" alt="Loading" style="height: 200px; height: 200px; padding: 10px;">
    </div>

  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "UserSectionView",
  data() {
    return {
      userSection: [],
      userSectionData: {
        name: "",
      },
      loaded: false,
    };
  },
  mounted() {
    this.getUserSection();
  },
  methods: {
    async getUserSection() {
      try {
        const response = await this.$axios.get(
          "usersSections/sections/" +
          this.$route.params.id
        );
        //console.log("Respuesta del servidor:", response.data);
        this.userSection = response.data;
        this.loaded = true;
      } catch (error) {
        //console.error("Error al realizar la solicitud GET:", error);
      }
    },
    goToRoute(route) {
      router.push("/see-specific-user/" + this.$route.params.id + "/" + route);
    },
  },
};
</script>

<style scoped>
.userSection {
  flex: 1;
  background-color: var(--not-so-grey);
  display: flex;
  align-items: center;
  justify-content: center;
}

p {
  margin: 0;
}

.container {
  width: 70%;
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.flex-cards {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
}

.card {
  cursor: pointer;
  background-color: #f4f8f7;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 200px;
  height: 200px;
  padding: 10px;
  gap: 10px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  transition: all ease-out 0.5s;
  -webkit-transition: all ease-out 0.5s;
  -moz-transition: all ease-out 0.5s;
  -ms-transition: all ease-out 0.5s;
  -o-transition: all ease-out 0.5s;
}

.card-title {
  font-size: 20px;
  font-weight: bold;
}

.card-content {
  color: var(--another-grey);
}

.card-content-other {
  font-style: italic;
}

.card-add {
  align-items: center;
  justify-content: center;
}

.card:hover {
  transform: scale(1.05);
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
}
</style>